import { navItems, directions, genres } from "@/mocks/siteData";

export default function SiteFooter() {
  const handleGo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-secondary-800 text-secondary-100">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-planet-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">星辰影院</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200">
              一个围绕在线观看与播放需求整理的中文信息页面，梳理在线观看、免费观看、高清播放与手机在线等方向，并补充抢先看与全集在线内容，方便对照核对。
            </p>
            <div className="flex items-center gap-1.5 mt-5 text-accent-400">
              <i className="ri-star-fill text-sm" aria-hidden="true"></i>
              <i className="ri-star-fill text-sm" aria-hidden="true"></i>
              <i className="ri-star-fill text-sm" aria-hidden="true"></i>
              <i className="ri-star-fill text-sm" aria-hidden="true"></i>
              <i className="ri-star-half-fill text-sm" aria-hidden="true"></i>
              <span className="text-xs text-secondary-300 ml-1">内容持续整理中</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#directions" onClick={(e) => { e.preventDefault(); handleGo("directions"); }} className="hover:text-accent-400 transition-colors">
                页面分区
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {navItems.slice(0, 5).map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => handleGo(item.id)}
                    className="text-secondary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#modes" onClick={(e) => { e.preventDefault(); handleGo("modes"); }} className="hover:text-accent-400 transition-colors">
                播放方向
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {directions.map((d) => (
                <li key={d.title}>
                  <button
                    onClick={() => handleGo("modes")}
                    className="text-secondary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {d.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#genres" onClick={(e) => { e.preventDefault(); handleGo("genres"); }} className="hover:text-accent-400 transition-colors">
                题材分类
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {genres.slice(0, 5).map((g) => (
                <li key={g.id}>
                  <button
                    onClick={() => handleGo("genres")}
                    className="text-secondary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {g.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>星辰影院 · 本站为内容整理与说明页面，具体内容以实际播放页为准。</p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-1.5 text-secondary-200 hover:text-accent-400 transition-colors cursor-pointer"
          >
            回到顶部
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}